module.exports = __webpack_public_path__ + "static/media/CY2024 LIS Resource Limits Memo_508.299bcb91.pdf";